import { connect } from 'react-redux';
import { showReportModal as showReportModalAction } from '../../../../Moderation/redux/actions';
import { deleteDeviation as deleteDeviationAction } from '../../../../redux/deviations/actionCreators';
import { showMobileDeviationSharePopup } from '../../../../Modals/redux/actionCreators';
import { addNotification } from '../../../../Notifications/redux/actionCreators';
import { NotificationType } from '../../../../Notifications/redux/types';
var mapDispatchToProps = function (dispatch, _a) {
    var deviation = _a.deviation;
    return {
        showReportModal: function () { return dispatch(showReportModalAction(deviation)); },
        deleteDeviation: function () { return dispatch(deleteDeviationAction({ deviation: deviation })); },
        showMobileSharePopup: function () {
            return dispatch(showMobileDeviationSharePopup(deviation));
        },
        showGenericNotification: function (params) {
            return dispatch(addNotification(NotificationType.Generic, params));
        },
    };
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=FeedCardLayout.container.js.map